import apiFetch from '../apiFetch'

export default function (idRuta, token) {
  return apiFetch({endPoint: `Cliente/obternerTransportistaRuta`, method: 'POST', body: idRuta, token: token})
}